<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  add,
  getChannel,
  getDetails,
  update,
  del
} from "@/api/tracker/channel";
import { getCountry } from "@/api/system/country";
import { getAgent } from "@/api/tracker/agent";
import { getParams } from "@/api/tracker/params";
import { getStatus } from "@/api/tracker/status";
import { getMethod } from "@/api/system/method";
import { getWarehouse } from "@/api/storage/warehouse";
// import { add, getStatus, getDetails, update, del } from "@/api/tracker/status";
import { getSelectType } from "@/api/public";
import cTable from "@/base/common/index";
export default {
  name: "channel",
  components: {
    cTable
  },

  async mounted() {
    let fromCountry = (await getCountry({ allow_depart: 1 })).data.payload.rows;
    let targetCountry = (await getCountry({ allow_arrive: 1 })).data.payload
      .rows;
    // let agentIdList = (await getAgent({ types: "DELIVERY" })).data.payload.rows;
    // let trackerList = (await getStatus()).data.payload.rows;
    // let clearanceList = (await getAgent({ types: "CLEARANCE" })).data.payload
    //   .rows;
    // let transportList = (await getMethod()).data.payload.rows;
    this.header.searchs.forEach(item => {
      if (item.key === "fromCountry") item.options = fromCountry;
      if (item.key === "targetCountry") item.options = targetCountry;
    });
  },
  methods: {},
  data() {
    let publishList = [
      {
        label: "YES",
        value: "YES"
      },
      {
        label: "NO",
        value: "NO"
      }
    ];

    return {
      methods: {
        list: getChannel,
        getAgent,
        getParams,
        getStatus,
        getMethod,
        getWarehouse,
        add,
        getDetails,
        update,
        del,
        getSelectType
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: "70%"
            },
            formBind: {
              labelWidth: 150
            },
            colBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              channel_name: [
                {
                  required: true,
                  message: "airwayBillNumber cannot be empty",
                  trigger: "blur"
                }
              ],
              channel_code: [
                {
                  required: true,
                  type: "number",
                  trigger: "blur"
                }
              ],
              from_country: [
                {
                  required: true,
                  message: "type cannot be empty",
                  trigger: "blur"
                }
              ],
              from_city: [
                {
                  required: true,
                  message: "type cannot be empty",
                  trigger: "blur"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "type cannot be empty",
                  trigger: "blur"
                }
              ],
              transport_code: [
                {
                  required: true,
                  message: "type cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { channel_name: 11,channel_name_en: 11, channel_code: 11 ,
             from_country: 11, from_city: 11 ,
             to_country: 11, weights: 11 ,
             logo: 11, delivery_agent_id: 11 ,
             delivery_agent_params_id: 11, delivery_agent_tracker_id: 11 ,
             clearance_agent_id: 11, clearance_agent_params_id: 11 ,
             prefix: 11, transport_code: 11 ,
             delivery_mode: 11, battery: 11 ,
             warehouse_id: 11, type: 11 ,
             is_publish: 11, mappingChannel: 11,dd_type: 11,  allow_category: 11}
          ],
          fields: [
						{
							name: () => this.$t("taxationType"),
							key: "dd_type",
							component: "Select",
							placeholder() {
							  return this.$t("select") + this.$t("taxationType");
							},
							bind: {
								border: true
							},
							options: [{
									label: 'DDP',
									value: 'DDP',
								},
								{
									label: 'DDU',
									value: 'DDU',
								}
							],
							default: '',
						},
            {
              key: "channel_name",
              name: () => this.$t("channel_name"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("channel_name");
              }
            },
						{
						  key: "channel_name_en",
						  name: () => this.$t("channel_english_name"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("channel_english_name");
						  }
						},
            {
              key: "channel_code",
              name: () => this.$t("channel_code"),
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("channel_code");
              },
              bind: {
                step: 1,
                min: 0,
                style: "width:100%"
              },
              default: 0
            },
            {
              key: "from_country",
              name: () => this.$t("from_country"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("from_country");
              }
            },
            {
              key: "from_city",
              name: () => this.$t("from_city"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("from_city");
              }
            },
            {
              key: "to_country",
              name: () => this.$t("target_country"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("target_country");
              }
            },
            {
              key: "weights",
              name: () => this.$t("weights"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("weights");
              }
            },
            {
              key: "logo",
              name: () => this.$t("channel_logo"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("channel_logo");
              }
            },
            {
              key: "delivery_agent_id",
              name: () => this.$t("agentName"),
              component: "Select",
              config: {
                label: "agent_name",
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("agentName");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getAgent", {
                      types: "DELIVERY"
                    })
                  ).payload.rows;
                  this.$forceUpdate();
                },
                "on-change"({ value, fields, row }) {
                  this.$page
                    .handleRequestMethods("getParams", {
                      agent_id: value
                    })
                    .then(res => {
                      fields.forEach(item => {
                        if (item.key === "delivery_agent_params_id") {
                          item.options =
                            res.payload.rows.length > 0 ? res.payload.rows : [];
                          item.disabled = res.payload.rows.length < 1;
                          if (!res.payload.rows.length) {
                            row["delivery_agent_params_id"] = "";
                            this.$Message["error"]({
                              background: true,
                              content: "Please maintain Agent Params",
                              duration: 5
                            });
                          }
                        }
                      });
                      this.$forceUpdate();
                    });
                }
              }
            },
            {
              key: "delivery_agent_params_id",
              name: () => this.$t("delivery_agent"),
              component: "Select",
              config: {
                label: "params_account",
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("delivery_agent");
              },
              options: [],
              disabled: true
            },
            {
              key: "delivery_agent_tracker_id",
              name: () => this.$t("delivery_agent_tracker"),
              component: "Select",
              config: {
                label: "tracker_code",
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("delivery_agent_tracker");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getStatus")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "clearance_agent_id",
              name: () => this.$t("clearance_agent"),
              component: "Select",
              config: {
                label: "agent_name",
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("clearance_agent");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getAgent", {
                      types: "CLEARANCE"
                    })
                  ).payload.rows;
                  this.$forceUpdate();
                },
                "on-change"({ value, fields, row }) {
                  this.$page
                    .handleRequestMethods("getParams", {
                      agent_id: value
                    })
                    .then(res => {
                      fields.forEach(item => {
                        if (item.key === "clearance_agent_params_id") {
                          item.options =
                            res.payload.rows.length > 0 ? res.payload.rows : [];
                          item.disabled = res.payload.rows.length < 1;
                          if (!res.payload.rows.length) {
                            row["clearance_agent_params_id"] = "";
                            this.$Message["error"]({
                              background: true,
                              content: "Please maintain Agent Params",
                              duration: 5
                            });
                          }
                        }
                      });
                      this.$forceUpdate();
                    });
                }
              }
            },
            {
              key: "clearance_agent_params_id",
              name: () => this.$t("clearance_agent_params"),
              component: "Select",
              config: {
                label: "params_account",
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("clearance_agent_params");
              },
              options: [],
              disabled: true
            },
            {
              key: "prefix",
              name: () => this.$t("prefix"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("prefix");
              }
            },
            {
              key: "transport_code",
              name: () => this.$t("method_code"),
              component: "Select",
              config: {
                label({ row }) {
                  return row.method_name + "(" + row.method_code + ")";
                },
                value: "method_code"
              },
              placeholder() {
                return this.$t("select") + this.$t("method_code");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getMethod")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "warehouse_id",
              name: () => this.$t("warehouseName"),
              component: "Select",
              config: {
                label: "title",
                value: "id"
              },
              placeholder() {
                return this.$t("select") + this.$t("warehouseName");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getWarehouse")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
              // options:async()=> await getWarehouse({ is_oversea: "NO", status: "ENABLE" })
            },
            {
              key: "type",
              name: () => this.$t("type"),
              component: "Select",
              config: {
                label({ row }) {
                  return this.$t(row.label);
                }
              },
              placeholder() {
                return this.$t("select") + this.$t("type");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods(
                      "getSelectType",
                      "ORDERS_TYPE"
                    )
                  ).payload["ORDERS_TYPE"];
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "is_publish",
              name: () => this.$t("is_publish"),
              component: "Radio",
              default: "NO",
              options: publishList,
              bind: {
                border: true
              }
            },
            {
              key: "mappingChannel",
              name: () => this.$t("mappingChannel"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("mappingChannel");
              }
            },
						{
						  key: "delivery_mode",
						  name: () => this.$t("DeliveryMode"),
						  component: "Select",
						  placeholder() {
						    return this.$t("select") + this.$t("DeliveryMode");
						  },
						  options: [],
						  methods: {
						    async list({ field }) {
						      field.options = (
						        await this.$page.handleRequestMethods(
						          "getSelectType",
						          "AE_IL_DELIVERY_MODE"
						        )
						      ).payload["AE_IL_DELIVERY_MODE"];
						      this.$forceUpdate();
						    }
						  }
						},
						{
						  key: "battery",
						  name: () => this.$t("Battery"),
						  component: "Select",
						  placeholder() {
						    return this.$t("select") + this.$t("Battery");
						  },
						  options: [],
						  methods: {
						    async list({ field }) {
						      field.options = (
						        await this.$page.handleRequestMethods(
						          "getSelectType",
						          "BATTERY_SELECT_TYPE"
						        )
						      ).payload["BATTERY_SELECT_TYPE"];
						      this.$forceUpdate();
						    }
						  }
						},
            {
              name: () => this.$t("allowCategory"),
              key: "allow_category",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("allowCategory");
              },
              bind: {
                border: true
              },
              options: [],
              config: {
                label: "name",
                value: "id"
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods(
                      "getSelectType",
                      "CHANNEL_ALLOW_CATEGORY"
                    )
                  ).payload["CHANNEL_ALLOW_CATEGORY"];
                  this.$forceUpdate();
                }
              },
              default: '',
            },
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "fromCountry",
            placeholder() {
              return this.$t("select") + this.$t("from_station");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code"
            }
          },
          {
            key: "targetCountry",
            placeholder() {
              return this.$t("select") + this.$t("to_station");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add"
              },
              id: 168
            }
          ],
          methods: {
            addFun({ field, searchForm }) {
              this.getModal("add").open({}, function() {
                this.setTitle(this.$t("add"));
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("channel_name"),
          key: "channel_name",
          align: "left",
          minWidth: 200
        },
				{
				  name: () => this.$t("channel_english_name"),
				  key: "channel_name_en",
				  align: "left",
				  minWidth: 200
				},
        {
          name: () => this.$t("channel_code"),
          key: "channel_code",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("from_city"),
          key: "from_city",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("channel_logo"),
          key: "logo",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("allowCategory"),
          key: "allow_category",
          align: "left",
          minWidth: 100,
          component:'Button',
          bind:{
            type:'primary',
            size:'small',
            multiple: true
          },
          disabled({row}){
            return !row['allowCategory']
          },
          methods: {
            render(v) {
              if (v.row.allowCategory) {
                return v.row.allowCategory.name
              }
              return '尚未绑定'
            },
            click({row}){
              const msg = row.allowCategory.details2 || row.allowCategory.details || row.allowCategory.remakrs
              if (msg) {
                alert(msg)
              }
            }
          }
        },
        {
          name: () => this.$t("agentName"),
          key: "delivery_agent_name",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("delivery_agent"),
          key: "delivery_params_account",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("delivery_agent_tracker"),
          key: "code_tracker_code",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("clearance_agent"),
          key: "clearance_agent_name",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("clearance_agent_params"),
          key: "clearance_params_account",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("prefix"),
          key: "prefix",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("method_code"),
          key: "transport_code",
          align: "center",
          minWidth: 100
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success"
              },
              id: 169
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error"
              },
              id: 170
            }
          ],

          methods: {
            async updateFun({ row }) {
              console.log(row);
              let res = await this.handleRequestMethods("getDetails", {
                id: row.id
              });
              console.log("res", res);

              this.getModal("add").open(res.payload, function() {
                console.log(this);
                this.setTitle(this.$t("update"));
              });
            },
            async operationFun({ row }) {
              this.getModal("operation").open(
                {
                  packageId: row.id
                },
                function() {
                  this.setTitle(this.$t("operation"));
                }
              );
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("channel_name") +
                  ":" +
                  row.channel_name +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    {
                      id: row.id
                    },
                    true
                  ).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
